(() => {
  function init(root) {
    if (root.dataset.ebInitialized) return;
    root.dataset.ebInitialized = 'true';
    const config = JSON.parse(root.querySelector('[data-eb-config]').textContent);
    const form = root.querySelector('[data-eb-form]');
    const panels = [...root.querySelectorAll('[data-eb-panel]')];
    const steps = [...root.querySelectorAll('[data-eb-step]')];
    const buy = root.querySelector('[data-eb-buy]');
    const variantInput = root.querySelector('[data-eb-variant]');
    const error = root.querySelector('[data-eb-error]');
    const material = form.querySelector('[name="properties[Enlace al material]"]');
    const source = form.querySelector('[name="properties[Punto de partida]"]');
    const liveVariants = config.variants || [];
    const variants = liveVariants.length ? liveVariants : config.fallback;
    const money = new Intl.NumberFormat(config.locale === 'es' ? 'es-AR' : (config.locale || 'es-AR'), {style:'currency', currency:config.currency || 'ARS', currencyDisplay:'narrowSymbol', maximumFractionDigits:0});
    const fmt = cents => `${money.format(cents / 100)} ${config.currency || 'ARS'}`;
    let current = 0;
    let selected;
    let busy = false;
    form.noValidate = true;
    function setStep(index, focus = true) {
      current = index;
      root.dataset.ebCurrent = String(index);
      panels.forEach((p,i) => {p.hidden = i !== index;});
      steps.forEach((s,i) => i === index ? s.setAttribute('aria-current','step') : s.removeAttribute('aria-current'));
      if (focus) {
        const heading = root.querySelector('[data-eb-heading]');
        heading.focus({preventScroll:true});
        heading.scrollIntoView({block:'start', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }
    }
    function validPanel(index) {
      const controls = [...panels[index].querySelectorAll('input,select,textarea')];
      for (const control of controls) {
        if (control.type !== 'checkbox') {
          control.setCustomValidity('');
          if (control.required && !control.value.trim()) control.setCustomValidity(config.blankError);
        }
        if (!control.checkValidity()) {
          setStep(index, false);
          control.focus();
          control.reportValidity();
          return false;
        }
      }
      return true;
    }
    function moveTo(index) {
      if (busy) return;
      if (index > current) for(let i=0;i<index;i++) if(!validPanel(i)) return;
      setStep(index);
    }
    function update() {
      const pages = form.querySelector('[name="eb_pages"]:checked').value;
      const style = form.querySelector('[name="eb_style"]:checked').value;
      selected = variants.find(v => v.options[0] === pages && v.options[1] === style);
      const delivery = config.deliveryText;
      root.querySelector('[data-eb-pages]').textContent = pages;
      root.querySelector('[data-eb-style]').textContent = style;
      root.querySelector('[data-eb-price]').textContent = selected && selected.price > 0 ? fmt(selected.price) : config.pricePending;
      root.querySelector('[data-eb-delivery]').textContent = delivery;
      root.querySelector('[data-eb-delivery-property]').value = config.deliveryProperty;
      material.required = source.selectedIndex === 1;
      const canBuy = liveVariants.length > 0 && selected && selected.available && selected.price > 0;
      variantInput.value = canBuy ? selected.id : '';
      variantInput.disabled = !canBuy;
      buy.disabled = !canBuy || busy;
      root.querySelector('[data-eb-state]').textContent = canBuy ? '' : config.wait;
      const positive = variants.filter(v=>v.price>0).map(v=>v.price);
      if(positive.length) root.querySelector('[data-eb-from]').textContent=fmt(Math.min(...positive));
    }
    form.addEventListener('input', event => {
      if (event.target.setCustomValidity) event.target.setCustomValidity('');
    });
    form.addEventListener('change', update);
    root.querySelectorAll('[data-eb-next],[data-eb-summary-next]').forEach(el=>el.addEventListener('click',()=>moveTo(Math.min(current+1,2))));
    root.querySelectorAll('[data-eb-back]').forEach(el=>el.addEventListener('click',()=>moveTo(Math.max(current-1,0))));
    steps.forEach(el=>el.addEventListener('click',()=>moveTo(Number(el.dataset.ebStep))));
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy) return;
      for(let i=0;i<panels.length;i++) if(!validPanel(i)) return;
      update();
      if (buy.disabled || !selected || !selected.id) return;
      busy = true;
      buy.disabled = true;
      buy.textContent = config.adding;
      error.hidden = true;
      steps.forEach(button=>button.disabled=true);
      const data = new FormData(form);
      data.delete('eb_pages');
      data.delete('eb_style');
      data.delete('return_to');
      for (const [key,value] of [...data.entries()]) if (typeof value === 'string') data.set(key,value.trim());
      try {
        const base = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${base}cart/add.js`, {method:'POST', body:data, headers:{'Accept':'application/json'}});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(config.error);
        window.location.assign(`${base}cart`);
      } catch {
        error.textContent = config.error;
        error.hidden = false;
        busy = false;
        buy.textContent = config.buy;
        steps.forEach(button=>button.disabled=false);
        update();
      }
    });
    root.classList.add('eb-ready');
    setStep(0,false);
    update();
  }
  document.querySelectorAll('[data-ebook-section]').forEach(init);
  document.addEventListener('shopify:section:load', event=>event.target.querySelectorAll('[data-ebook-section]').forEach(init));
})();
